import { uiComponents, uiStates } from '../tools/viewState';
import { generateUUID } from '@/tools/helpers';
export default {
	articleContent: {},
	behaviour: 'mobile',
	blocksReady: false,
	browserBarColor: null,
	calendarEvents: [],
	contentIsLoading: false,
	contentModalIsLoading: false,
	cssDevMode: false,
	currentArticleID: null,
	currentAugmentedRealityArticle: null,
	augmentedRealityPreviousPath: '',
	currentExhibitionID: null,
	currentMediaObjectMap: new Map(),
	dataSourceCFG: null,
	dataSourceURL: null,
	defaultLanguage: 'en',
	glossary: [],
	glossaryByKeyword: [],
	glossaryMap: {},
	hasNativeInterface: false,
	isDevServer: false,
	isVirtualPackageSyncer: false,
	isPreviewDataSource: false,
	isLoaner: false,
	isPreview: false,
	loadedStoreModules: {},
	messages: [], // [{body: 'this is an error', type: 'error', sticky: false}]
	navigation: {
		bottom: [],
		left: [],
		right: [],
		theme: 'default',
		top: [],
		modal: [],
		tour: [],
	}, // ** Media Stuff */
	persistent: {
		language: (navigator.language || navigator.userLanguage).substr(0, 2),
		webClientID: generateUUID(),
	},
	pageScroll: {},
	pageTransitionMode: null,
	isApp: false,
	styleLoaded: false,
	styleTemplateURL: null,
	visitedArticleIDs: {},
	visitedLocationIDs: {},
	visitedExhibtionIDs: {},
	viewportSize: 0,
	viewportMode: 'portrait',
	fontSize: 'medium',
	colorMode: 'bright',
	imageSize: null, // This value will be dynamically determined
	viewState: Object.values(uiComponents).reduce((acc, uiComponent) => {
		acc[uiComponent] = {
			name: uiComponent,
			uiState: uiComponent === uiComponents.uiLoader ? uiStates.maximised : uiStates.hidden,
		};
		return acc;
	}, {}),
	modal: null,
	urlIsValidated: false,
	mediaplayer: {
		mode: '',
		mac: '',
	},
	itIsNoScreenReader: false,
	routeChangedByBrowser: false,
	routeUserClicked: false,
};
